import React, { useState, useEffect } from "react";
import { XCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css-dashboard/Dashboard.css";
import SidebarTraveler from "../../components/sidebar-dashboard/SidebarTraveler";
import TravelerTripsProgressNegotiations from "../../components/traveler-trips-negotiations/TravelerTripsProgressNegotiations";
import UseTravelerTripsNegotiations from "../../hooks/UseTripsNegotiations/UseTravelerTripsNegotiations";
import UseTripNegotiationPayment from "../../hooks/UsePaymentServiceTripNegotiation/UsePaymentServiceTripNegotiation";
import UseNotAcceptOrderTripNegotiation from "../../hooks/UseNotAcceptOrderTripNegotiation/UseNotAcceptOrderTripNegotiation";
import UseNotAcceptOrderTripAvailable from "../../hooks/UseNotAcceptOrderTripAvailable/UseNotAcceptOrderTripAvailable";
import TravelsAvailable from "../../components/travels-available/TravelsAvailable";
import UseTripsAvailable from "../../hooks/UseTripsAvailable/UseTripsAvailable";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";

const placeholderImage =
  "https://img.magnific.com/premium-vector/3d-cardboard-box-clipboard-with-tick-confirmed-order-delivery-concept-shipment-checklist-delivery-order-cardboard-box-fast-delivery-concept-mail-by-courier-vector-illustration_221648-1116.jpg?semt=ais_hybrid&w=740&q=80";

const placeholderImage2 =
  "https://img.magnific.com/free-vector/expenses-calculation-wishlist-planning-shopping-list-purchases-summary-internet-supermarket-basket-shopper-wishlist-creative-design-element_335657-1631.jpg?semt=ais_hybrid&w=740&q=80";

const TripsProgressTraveler = ({ menuOpen, setMenuOpen }) => {
  const location = useLocation();
  const { state, pathname } = location;
  const navigate = useNavigate();

  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const [showMsgRefuseModal, setShowMsgRefuseModal] = useState("");
  const [serieCancelOrder, setSerieCancelOrder] = useState("");
  const [serieCancelTripsAvailable, setSerieCancelTripsAvailable] =
    useState("");
  const [modalWarning, setModalWarning] = useState(true);
  const [fromNotification, setFromNotification] = useState(null);
  const [imageNotification, setImageNotification] = useState(null);
  const [messageNotification, setMessageNotification] = useState(null);

  const { tripsAvailable, loadingTripsAvailable } = UseTripsAvailable();
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseTravelerTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,
    modePhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  const { paymentInsurance } = UseTripNegotiationPayment(() => {
    refetchTripsNegotiations();
  });

  const { loadingCancelOrder, cancelOrder } =
    UseNotAcceptOrderTripNegotiation();

  const { loadingCancelOrderTripAvailable, cancelOrderTripAvailable } =
    UseNotAcceptOrderTripAvailable();

  const handleCancelOrder = async (serie) => {
    await cancelOrder(serie, "traveler");
    setShowRefuseModal(false);
  };

  const handleCancelTripsAvailable = async (serie) => {
    await cancelOrderTripAvailable(serie);
    setShowRefuseModal(false);
  };

  useEffect(() => {
    if ((fromNotification && state?.from) || state?.notification_type) {
      window.location.reload();
      navigate(pathname, {
        replace: true,
        state: {
          ...state,
          from: null,
          notification_type: null,
        },
      });
    }
  }, [
    fromNotification,
    state?.from,
    state?.notification_type,
    pathname,
    navigate,
  ]);

  useEffect(() => {
    const state = location.state;
    if (!state || !state.from) return;

    const type = state.notification_type?.trim();
    const item = state.item;

    console.log(location.state?.item);

    if (type === "receiver-selected-traveler") {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.receiver?.imagem);
      setMessageNotification(
        <>
          Agora que o destinatário{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.receiver?.nome}
          </span>{" "}
          confirmou a sua disponibilidade, você já pode seguir com os próximos
          passos.
        </>,
      );
    } else if (type === "receiver-refused") {
      openModalReceiverData(item, "receiverReadded");
    } else if (
      location.state?.item?.is_traveler_photos_confirmed === false &&
      type === "photo-confirmation"
    ) {
      setFromNotification("notification");
      setImageNotification(location.state?.item?.traveler?.imagem);
      setMessageNotification(
        <>
          Agora que o cliente{" "}
          <span style={{ fontWeight: 800, color: "#111827" }}>
            {location.state?.item?.traveler?.nome}
          </span>{" "}
          enviou as fotografias da encomenda, por favor, faça a confirmação.
        </>,
      );
    } else if (type === "chat") {
      openChatModal(item, "traveler");
    } else if (type === "cancel-order-traveler") {
      setFromNotification("notification");
      setImageNotification(placeholderImage);
      setMessageNotification(<>Encomenda recusada com sucesso.</>);
    } else if (type === "trip-updated") {
      setFromNotification("notification");
      setImageNotification(placeholderImage2);
      setMessageNotification(<>Viagem editada com sucesso.</>);
    }
  }, [location]);

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarTraveler menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Viajante</h1>
            <p className="breadcrumb">
              <a href="/dashboard-travelers">Início</a> / Viagens em Andamento
            </p>
          </div>

          <TravelerTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            paymentInsurance={paymentInsurance}
            setSerieCancelOrder={setSerieCancelOrder}
            setShowRefuseModal={setShowRefuseModal}
            setShowMsgRefuseModal={setShowMsgRefuseModal}
          />

          {/*<TravelsAvailable
            tripsAvailable={tripsAvailable}
            loadingTripsAvailable={loadingTripsAvailable}
            setSerieCancelTripsAvailable={setSerieCancelTripsAvailable}
            setShowMsgRefuseModal={setShowMsgRefuseModal}
            setShowRefuseModal={setShowRefuseModal}
          />*/}
        </main>
      </div>

      <ModalReceiverData
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder={modePhotosOrder}
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      {modalWarning && fromNotification === "notification" && (
        <div
          className="modal-overlay"
          onClick={() => {
            setModalWarning(false);
            setFromNotification(null);
          }}
          style={{
            alignItems: "flex-start",
            overflowY: "auto",
            padding: "20px 12px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "520px",
              margin: "auto",
              padding: "32px 28px",
              borderRadius: "30px",
              overflow: "hidden",
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0.92))",
              backdropFilter: "blur(18px)",
              WebkitBackdropFilter: "blur(18px)", // Garante suporte para o Safari
              boxShadow:
                "0 20px 60px rgba(15, 124, 255, 0.18), 0 8px 20px rgba(0, 0, 0, 0.06)",
              textAlign: "center",
            }}
          >
            <>
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    width: "155px",
                    height: "155px",
                    margin: "auto",
                    borderRadius: "50%",
                    padding: "5px",
                    background: "linear-gradient(135deg, #0f7cff, #19b8ff)",
                    boxShadow:
                      "0 14px 35px rgba(15, 124, 255, 0.35), 0 5px 14px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.35s ease",
                  }}
                >
                  <img
                    src={imageNotification}
                    alt="Foto de perfil"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "5px solid #fff",
                      display: "block",
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  textAlign: "left",
                  color: "#616367",
                  marginBottom: "6px",
                }}
              >
                {messageNotification || ""}
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={() => {
                    setModalWarning(false);
                    setFromNotification(null);
                  }}
                >
                  Entendi
                </button>
              </div>
            </>
          </div>
        </div>
      )}

      {showRefuseModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowRefuseModal(false)}
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "500px",
              background: "#fff",
              borderRadius: "24px",
              padding: "30px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            }}
          >
            <XCircle
              size={70}
              color="#ef4444"
              style={{ marginBottom: "16px" }}
            />

            <h2
              style={{
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              {showMsgRefuseModal === "trip_negotiations" ||
              showMsgRefuseModal === "cancel_travel_available" ? (
                <span>Confirmar cancelamento</span>
              ) : (
                "Aviso"
              )}
            </h2>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.6,
                marginBottom: "24px",
              }}
            >
              {showMsgRefuseModal === "trip_negotiations" ? (
                <span>Tem certeza que deseja não levar esta encomenda?</span>
              ) : showMsgRefuseModal === "cancel_travel_available" ? (
                <span>Tem certeza que deseja cancelar essa viagem?</span>
              ) : (
                <span>Não pode editar uma viagem ja em negociacao</span>
              )}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                onClick={() => setShowRefuseModal(false)}
                className="action-btn ghost"
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                {showMsgRefuseModal === "trip_negotiations" ||
                showMsgRefuseModal === "cancel_travel_available" ? (
                  <span>Voltar</span>
                ) : (
                  "Entendi"
                )}
              </button>

              {(showMsgRefuseModal === "trip_negotiations" ||
                showMsgRefuseModal === "cancel_travel_available") && (
                <button
                  type="button"
                  className="refuse-order-btn"
                  onClick={() => {
                    if (showMsgRefuseModal === "trip_negotiations") {
                      handleCancelOrder(serieCancelOrder);
                    } else if (
                      showMsgRefuseModal === "cancel_travel_available"
                    ) {
                      handleCancelTripsAvailable(serieCancelTripsAvailable);
                    }
                  }}
                  disabled={
                    loadingCancelOrder || loadingCancelOrderTripAvailable
                  }
                  style={{
                    width: "50%",
                    height: "50px",
                  }}
                >
                  {loadingCancelOrder || loadingCancelOrderTripAvailable
                    ? "Cancelando..."
                    : "Sim, cancelar"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TripsProgressTraveler;
